module.exports = __webpack_public_path__ + "static/media/img-23.39e7eb9b.jpg";